import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import { i18n } from '@/core/i18n';
import { IdentityService } from '@/services/identity-service';

@Component
export default class LoggedOut extends mixins(i18n.Mixins.Culture) {
    @Prop({ default: '' })
    returnUrl!: string;

    async goToLogin() {
        if (!this.returnUrl) {
            const { success, data } = await IdentityService.getUrls(this.getLang());

            window.location.href = (success && data?.signInUrl)
                ? data.signInUrl
                : process.env.VUE_APP_SELFCARE_URL;

            return;
        }

        this.$router.push({ name: 'login', query: { ReturnUrl: this.returnUrl } });
    }
}
